import { render, staticRenderFns } from "./20-member-profile-extras.vue?vue&type=template&id=a61003dc&scoped=true"
import script from "./20-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./20-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./20-member-profile-extras.vue?vue&type=style&index=0&id=a61003dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61003dc",
  null
  
)

export default component.exports